<template>
  <div
    v-if="activity.content && activity.content.stay_research_type && activity.content.stay_research_type.id === 55"
    class="card"
  >
    <div class="card-header">
      <h3 class="cart-title">
        <a data-action="collapse">Field Work</a>
      </h3>
    </div>
    <div class="card-content">
      <div class="card-body">
        <p class="mb-1">
          Let's get your next fieldwork campaign ready!
          Please take a few minutes to fill in this <a
            href="https://form.jotform.com/261181874919367"
            target="_blank"
            rel="noopener noreferrer"
          >form</a> so we can prepare things properly to help you.
          If this is a recurring fieldwork and everything is the same as before, simply tick the box below to let us know.
        </p>
        <div class="form-check mb-1">
          <input
            id="fieldWorkAccepted"
            v-model="activity.content.field_work_accepted"
            class="form-check-input"
            type="checkbox"
            :value="true"
          >
          <label
            class="form-check-label"
            for="fieldWorkAccepted"
          >
            I've already completed the form, or this is a recurring fieldwork and everything is the same as before.
          </label>
        </div>
        <div class="mb-1">
          <label
            for="fieldWorkComment"
            class="form-label"
          >Comments (optional)</label>
          <textarea
            id="fieldWorkComment"
            v-model="activity.content.field_work_comment"
            class="form-control"
            rows="3"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activity: { type: Object, required: true },
  },
}
</script>
